export default __webpack_public_path__ + "images/image2.618c94a9.png";